/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface IdArray {
  ids?: number[]
}

export type EmptyResponse = string

export interface RfpLaneCarrierRateUpdateRequest {
  rfpLaneCarrierRate: {
    carrierApplicationId: string
    maxCapacity: number | null
    minCapacity: number | null
    canDoWeekends: boolean
    confirmed: boolean
    rateAttributes: {
      id: string
      amount: string
      rateTypeKey: string
    }
  }
}

export interface RfpLaneCarrierRateUpdateResponse {
  rfpLaneCarrierRate?: {
    canDoWeekends?: boolean
    carrierApplication?: {
      id?: number
      name?: string
    }
    confirmed?: boolean
    createdBy?: {
      id?: number
      parentUserId?: number
      fullName?: string
    }
    deliveryCity?: string
    deliveryDatMarket?: string
    deliveryStateCode?: string
    equipment?: {
      createdAt?: string | null
      id?: number
      key?: string
      name?: string
      parentId?: number
      position?: number
      updatedAt?: string
    }
    id?: number
    laneId?: string
    maxCapacity?: number | null
    minCapacity?: number | null
    pickupCity?: string
    pickupDatMarket?: string
    pickupStateCode?: string
    rate?: {
      amount?: string
      rateTypeKey?: string
    }
    requestForProposal?: {
      rfpTitle?: string
      salesforceRfpId?: string
      shipperName?: string
    }
    requestForProposalLaneId?: number
    rfpLaneDropType?: string
    rfpLaneGrossVolume?: string | null
    transfixShipperLaneId?: number | null
    updatedAt?: string | null
    updatedBy?: {
      fullName?: string
      id?: number
      parentUserId?: number
    }
  }
}

export interface RfpLaneCarrierRateCreateRequest {
  rfpLaneCarrierRate: {
    carrierApplicationId: string
    maxCapacity: number | null
    minCapacity: number | null
    canDoWeekends: boolean
    confirmed: boolean
    rateAttributes: {
      amount: string
      rateTypeKey: string
    }
    requestForProposalLaneId: string
  }
}

export interface RfpLaneCarrierRateBulkRequest {
  bulkTemplate?: {
    /**
     * Base64 Encoded File
     */
    file?: string
    fileFileName?: string
    uuid?: string
  }
}

export type RfpLaneCarrierRateFilters = string

export interface Error {
  data?: {
    errors?: string[]
  }
  code?: string
  message?: string
}

export interface ClientError {
  errors?: string[]
}

export interface GetRatesListQueryParams {
  sortField?: string
  filters?: RfpLaneCarrierRateFilters
}

export type GetRatesListProps = Omit<
  GetProps<void, ClientError, GetRatesListQueryParams, void>,
  'path'
>

/**
 * List of RFP Lane Carrier Rates
 */
export const GetRatesList = (props: GetRatesListProps) => (
  <Get<void, ClientError, GetRatesListQueryParams, void>
    path='/v9/request_for_proposal_lane_carrier_rates'
    {...props}
  />
)

export type UseGetRatesListProps = Omit<
  UseGetProps<void, ClientError, GetRatesListQueryParams, void>,
  'path'
>

/**
 * List of RFP Lane Carrier Rates
 */
export const useGetRatesList = (props: UseGetRatesListProps) =>
  useGet<void, ClientError, GetRatesListQueryParams, void>(
    `/v9/request_for_proposal_lane_carrier_rates`,
    props
  )

export type CreateRateProps = Omit<
  MutateProps<void, ClientError, void, RfpLaneCarrierRateCreateRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new carrier rate for an RFP lane
 */
export const CreateRate = (props: CreateRateProps) => (
  <Mutate<void, ClientError, void, RfpLaneCarrierRateCreateRequest, void>
    verb='POST'
    path='/v9/request_for_proposal_lane_carrier_rates'
    {...props}
  />
)

export type UseCreateRateProps = Omit<
  UseMutateProps<void, ClientError, void, RfpLaneCarrierRateCreateRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new carrier rate for an RFP lane
 */
export const useCreateRate = (props: UseCreateRateProps) =>
  useMutate<void, ClientError, void, RfpLaneCarrierRateCreateRequest, void>(
    'POST',
    `/v9/request_for_proposal_lane_carrier_rates`,
    props
  )

export type GetRatesCountProps = Omit<GetProps<void, ClientError, void, void>, 'path'>

/**
 * Count of total rows in filter
 */
export const GetRatesCount = (props: GetRatesCountProps) => (
  <Get<void, ClientError, void, void>
    path='/v9/request_for_proposal_lane_carrier_rates/count'
    {...props}
  />
)

export type UseGetRatesCountProps = Omit<UseGetProps<void, ClientError, void, void>, 'path'>

/**
 * Count of total rows in filter
 */
export const useGetRatesCount = (props: UseGetRatesCountProps) =>
  useGet<void, ClientError, void, void>(`/v9/request_for_proposal_lane_carrier_rates/count`, props)

export interface UpdateRatePathParams {
  id: string
}

export type UpdateRateProps = Omit<
  MutateProps<
    RfpLaneCarrierRateUpdateResponse,
    ClientError,
    void,
    RfpLaneCarrierRateUpdateRequest,
    UpdateRatePathParams
  >,
  'path' | 'verb'
> &
  UpdateRatePathParams

/**
 * Update an existing RFP Lane Carrier Rate
 */
export const UpdateRate = ({ id, ...props }: UpdateRateProps) => (
  <Mutate<
    RfpLaneCarrierRateUpdateResponse,
    ClientError,
    void,
    RfpLaneCarrierRateUpdateRequest,
    UpdateRatePathParams
  >
    verb='PUT'
    path={`/v9/request_for_proposal_lane_carrier_rates/${id}`}
    {...props}
  />
)

export type UseUpdateRateProps = Omit<
  UseMutateProps<
    RfpLaneCarrierRateUpdateResponse,
    ClientError,
    void,
    RfpLaneCarrierRateUpdateRequest,
    UpdateRatePathParams
  >,
  'path' | 'verb'
> &
  UpdateRatePathParams

/**
 * Update an existing RFP Lane Carrier Rate
 */
export const useUpdateRate = ({ id, ...props }: UseUpdateRateProps) =>
  useMutate<
    RfpLaneCarrierRateUpdateResponse,
    ClientError,
    void,
    RfpLaneCarrierRateUpdateRequest,
    UpdateRatePathParams
  >(
    'PUT',
    (paramsInPath: UpdateRatePathParams) =>
      `/v9/request_for_proposal_lane_carrier_rates/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export type DeleteRateProps = Omit<
  MutateProps<void, ClientError, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing RFP Lane Carrier Rate
 */
export const DeleteRate = (props: DeleteRateProps) => (
  <Mutate<void, ClientError, void, number, void>
    verb='DELETE'
    path='/v9/request_for_proposal_lane_carrier_rates'
    {...props}
  />
)

export type UseDeleteRateProps = Omit<
  UseMutateProps<void, ClientError, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing RFP Lane Carrier Rate
 */
export const useDeleteRate = (props: UseDeleteRateProps) =>
  useMutate<void, ClientError, void, number, void>(
    'DELETE',
    `/v9/request_for_proposal_lane_carrier_rates`,
    { ...props }
  )

export type BulkDeleteRatesProps = Omit<
  MutateProps<EmptyResponse, unknown, void, IdArray, void>,
  'path' | 'verb'
>

/**
 * Bulk Delete RFP Lane Carrier Rates
 */
export const BulkDeleteRates = (props: BulkDeleteRatesProps) => (
  <Mutate<EmptyResponse, unknown, void, IdArray, void>
    verb='POST'
    path='/v9/request_for_proposal_lane_carrier_rates/bulk_delete'
    {...props}
  />
)

export type UseBulkDeleteRatesProps = Omit<
  UseMutateProps<EmptyResponse, unknown, void, IdArray, void>,
  'path' | 'verb'
>

/**
 * Bulk Delete RFP Lane Carrier Rates
 */
export const useBulkDeleteRates = (props: UseBulkDeleteRatesProps) =>
  useMutate<EmptyResponse, unknown, void, IdArray, void>(
    'POST',
    `/v9/request_for_proposal_lane_carrier_rates/bulk_delete`,
    props
  )

export type BulkCreateRatesProps = Omit<
  MutateProps<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>,
  'path' | 'verb'
>

/**
 * Bulk Create RFP Lane Carrier Rates
 */
export const BulkCreateRates = (props: BulkCreateRatesProps) => (
  <Mutate<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>
    verb='POST'
    path='/v9/request_for_proposal_lane_carrier_rates/bulk_create'
    {...props}
  />
)

export type UseBulkCreateRatesProps = Omit<
  UseMutateProps<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>,
  'path' | 'verb'
>

/**
 * Bulk Create RFP Lane Carrier Rates
 */
export const useBulkCreateRates = (props: UseBulkCreateRatesProps) =>
  useMutate<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>(
    'POST',
    `/v9/request_for_proposal_lane_carrier_rates/bulk_create`,
    props
  )

export type BulkUpdateRatesProps = Omit<
  MutateProps<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>,
  'path' | 'verb'
>

/**
 * Bulk Update RFP Lane Carrier Rates
 */
export const BulkUpdateRates = (props: BulkUpdateRatesProps) => (
  <Mutate<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>
    verb='POST'
    path='/v9/request_for_proposal_lane_carrier_rates/bulk_update'
    {...props}
  />
)

export type UseBulkUpdateRatesProps = Omit<
  UseMutateProps<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>,
  'path' | 'verb'
>

/**
 * Bulk Update RFP Lane Carrier Rates
 */
export const useBulkUpdateRates = (props: UseBulkUpdateRatesProps) =>
  useMutate<void, ClientError, void, RfpLaneCarrierRateBulkRequest, void>(
    'POST',
    `/v9/request_for_proposal_lane_carrier_rates/bulk_update`,
    props
  )

export type BulkDownloadRatesProps = Omit<
  MutateProps<void, unknown, void, RfpLaneCarrierRateFilters, void>,
  'path' | 'verb'
>

/**
 * Bulk Download RFP Lane Carrier Rates
 */
export const BulkDownloadRates = (props: BulkDownloadRatesProps) => (
  <Mutate<void, unknown, void, RfpLaneCarrierRateFilters, void>
    verb='POST'
    path='/v9/request_for_proposal_lane_carrier_rates/bulk_download'
    {...props}
  />
)

export type UseBulkDownloadRatesProps = Omit<
  UseMutateProps<void, unknown, void, RfpLaneCarrierRateFilters, void>,
  'path' | 'verb'
>

/**
 * Bulk Download RFP Lane Carrier Rates
 */
export const useBulkDownloadRates = (props: UseBulkDownloadRatesProps) =>
  useMutate<void, unknown, void, RfpLaneCarrierRateFilters, void>(
    'POST',
    `/v9/request_for_proposal_lane_carrier_rates/bulk_download`,
    props
  )
